import { WPSlide, WPImageSlide, ImageSlide, SlideTypes } from "../../types/Slides";
import { getGlobalSlideData } from "../useProcessWordpressSlides";

export async function transformImageSlide(slide: WPSlide<WPImageSlide>, getImages: (ids: number) => Promise<string>,): Promise<ImageSlide[]> {
  const acfSlide = slide.acf;
  const text = acfSlide[SlideTypes.IMAGE].text
  return (
    await Promise.all(
      acfSlide[SlideTypes.IMAGE].images.map<Promise<ImageSlide>>(async (image, index) => ({
        type: SlideTypes.IMAGE,
        imageUrl: (await getImages(image)) ?? "",
        text: acfSlide[SlideTypes.IMAGE].textOnlyFirstImage ? (index === 0 ? text : "") : text,
        length: acfSlide[SlideTypes.IMAGE].length,
        ...getGlobalSlideData(slide)
      }))
    )
  ).filter((slide) => slide.imageUrl !== "");
}